/**
 * @author Simon
 * @description app ble
 */
// const FakeWebsocket = require('./fake-websocket');
// const Utils = require('./utils');
import FakeWebsocket from './fake-websocket.js';
import Utils from './utils.js';


class ScratchLinkApp {
    constructor(type) {
        this._type = type;
        this._onOpen = null;
        this._onClose = null;
        this._onError = null;
        this._handleMessage = null;

        this._ws = null;
        this._mobileOS = null;
    }

    open() {
        if (!(this._onOpen && this._onClose && this._onError && this._handleMessage)) {
            throw new Error('Must set open, close, message and error handlers before calling open on the socket');
        }

        this._ws = new FakeWebsocket();
        this._ws.onopen = this._onOpen;
        this._ws.onclose = this._onClose;
        this._ws.onerror = this._onError;
        this._ws.onmessage = this._onMessage.bind(this);
        this._mobileOS = Utils.getMobileOS();

        this._onOpen();
    }

    close() {
        this._ws = null;
    }

    sendMessage(message) {
        const messageText = JSON.stringify(message);
        if (this._mobileOS == 'iOS') {
            window.webkit.messageHandlers['bleSend'].postMessage(messageText);
        } else if (this._mobileOS == 'Android') {
            window.matatalab.bleSend(messageText);
        }
    }

    setOnOpen(fn) {
        this._onOpen = fn;
    }

    setOnClose(fn) {
        this._onClose = fn;
    }

    setOnError(fn) {
        this._onError = fn;
    }

    setHandleMessage(fn) {
        this._handleMessage = fn;
    }

    isOpen() {
        return this._ws;
    }

    _onMessage(e) {
        // const json = JSON.parse(e);
        this._handleMessage(e);
    }

    blueSendDataCallback(e) {
        // console.log(e);
        this._onMessage(e);
    }
}

// module.exports = ScratchLinkApp;
export default ScratchLinkApp;